export type AssistantMode = 'information' | 'compare' | 'compatibility'
export type Citation = { startIndex: number; endIndex: number; title: string; url: string }
export type AssistantResult = { answer: string; citations: Citation[]; checkedAt: string; cached: boolean }
export type AnswerPart = { text: string; citation?: Citation }
const record = (value: unknown): Record<string, unknown> | null => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : null

export function safeCitationUrl(value: unknown): value is string {
  if (typeof value !== 'string' || value.length > 1500 || [...value].some(char => char.charCodeAt(0) <= 32 || char.charCodeAt(0) === 127)) return false
  try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password && !url.port } catch { return false }
}

export function normalizeAssistantResult(value: unknown): AssistantResult {
  const result = record(value)
  if (!result || typeof result.answer !== 'string' || !result.answer.trim() || [...result.answer].length > 24000 || !Array.isArray(result.citations) || result.citations.length < 1 || result.citations.length > 100 || typeof result.checkedAt !== 'string' || !Number.isFinite(Date.parse(result.checkedAt)) || typeof result.cached !== 'boolean') throw new Error('Risposta non verificabile. Riprova più tardi.')
  const length = [...result.answer].length
  const citations = result.citations.map(raw => {
    const c = record(raw)
    if (!c || !Number.isInteger(c.startIndex) || !Number.isInteger(c.endIndex) || Number(c.startIndex) < 0 || Number(c.endIndex) <= Number(c.startIndex) || Number(c.endIndex) > length || typeof c.title !== 'string' || c.title.length > 300 || !safeCitationUrl(c.url)) throw new Error('La fonte della risposta non è valida.')
    return { startIndex: Number(c.startIndex), endIndex: Number(c.endIndex), title: c.title, url: c.url }
  })
  return { answer: result.answer, citations, checkedAt: result.checkedAt, cached: result.cached }
}

// Offsets are Unicode code points, not JS UTF-16; emoji before a source is safe.
export function citedAnswerParts(result: AssistantResult): AnswerPart[] {
  const chars = [...result.answer]; const parts: AnswerPart[] = []; let cursor = 0
  for (const citation of [...result.citations].sort((a, b) => a.startIndex - b.startIndex || a.endIndex - b.endIndex)) {
    if (citation.startIndex < cursor) continue
    if (citation.startIndex > cursor) parts.push({ text: chars.slice(cursor, citation.startIndex).join('') })
    parts.push({ text: chars.slice(citation.startIndex, citation.endIndex).join(''), citation }); cursor = citation.endIndex
  }
  if (cursor < chars.length) parts.push({ text: chars.slice(cursor).join('') })
  return parts
}
